import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export interface OpsSyncAnalyticsFilters {
  search: string | null;
  sales_admin_id: FilterValue[];
  pm_admin_id: FilterValue[];
  order_id: FilterValue[];
  order_type: FilterValue[] | null;
  product_ids: FilterValue[];
  customer_ids: FilterValue[];
  archived: FilterValue | null;
  start_date: Dayjs;
  end_date: Dayjs;
  sortBy: string;
  sortType: SortType;
}

export interface OpsSyncAnalyticsSelectedFilters {
  search: string | null;
  sales_admin_id: FilterValue[];
  pm_admin_id: FilterValue[];
  order_id: FilterValue[];
  order_type: FilterValue[] | null;
  product_ids: FilterValue[];
  customer_ids: FilterValue[];
  archived: FilterValue | null;
  start_date: string;
  end_date: string;
  sortBy: string;
  sortType: SortType;
}

export interface OpsSyncAnalyticsAPIFilters {
  sales_admin_id: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  archived: FilterValue | null;
  order_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  product_ids: FilterValue[] | null;
  customer_ids: FilterValue[] | null;
  start_date: string;
  end_date: string;
  sortBy?: string;
  sortType?: "ASC" | "DESC";
  search?: string;
}

export function parseQueryParamsForOpsSyncAnalyticsFilters(
  params: OpsSyncAnalyticsFilters | null,
  query_params: URLSearchParams,
): OpsSyncAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    search: params?.search ?? "",
    sales_admin_id: params?.sales_admin_id ?? [],
    pm_admin_id: params?.pm_admin_id ?? [],
    order_id: params?.order_id ?? [],
    archived: params?.archived ?? { id: "1", value: "Active" },
    order_type: params?.order_type ?? [],
    product_ids: params?.product_ids ?? [],
    customer_ids: params?.customer_ids ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    sortBy: params?.sortBy || "created_date",
    sortType: params?.sortType ?? SortType.DESC,
  };
}
